module.exports = __webpack_public_path__ + "static/media/pide-panda.6e7a4eca.png";